import React from "react";
import LoadingInput from "../../../../_components/LoadingInput";
import Text from "../../../../_components/Text";
import Button from "../../../../_components/Button";
import Modal from "../../../../_components/Modal";
import {
  createPaymentCostCenter,
  getPaymentCostCenter,
} from "../../../../api/financial";

export default (props) => {
  const ref = React.useRef();
  const [show, setShow] = React.useState(false);
  const [name, setName] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [costCenter, setcostCenter] = React.useState([]);

  function openModal() {
    setShow(true);
  }
  function closeModal() {
    setName("");
    setLoading(false);
    setShow(false);
  }
  function onChange(e) {
    if (props.onChange) {
      props.onChange({
        target: { name: "cost_center", value: e.target.value },
      });
    }
  }

  function onSave() {
    if (loading) {
      return;
    }
    setLoading(true);
    createPaymentCostCenter(name)
      .then((newCostCenter) => {
        setcostCenter([newCostCenter, ...costCenter]);
        setTimeout(() => {
          onChange({ target: { value: newCostCenter.id } });
          setLoading(false);
          closeModal();
        }, 400);
      })
      .catch((error) => { });
  }
  function onInit() {
    setLoading(true);
    getPaymentCostCenter()
      .then((data) => setcostCenter(data))
      .finally((error) => {
        setTimeout(() => setLoading(false), 1000);
      });
  }
  React.useEffect(onInit, [ref.current]);

  return (
    <div ref={ref}>
      <Text color="primary">{props.title}</Text>
      <LoadingInput onChange={onChange} loading={loading} as="select">
        <option selected>
          Sem Centro de Custo
        </option>
        {costCenter.map((paymentCostCenter) => (
          <option
            selected={props.selected == paymentCostCenter.id}
            key={paymentCostCenter.id}
            value={paymentCostCenter.id}
          >
            {paymentCostCenter.name}
          </option>
        ))}
      </LoadingInput>
      {
        props.allowCreate ?
          <Button as="text" className='text-secondary' onClick={openModal}>
            Criar Centro de Custo
          </Button>
          :
          <React.Fragment />
      }

      <Modal
        title="Criar centro de custo"
        show={show}
        onHide={closeModal}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-xs-12">
              <div className="form-group">
                <div className="form-label">
                  <Text color="primary">Nome do centro de custo</Text>
                </div>
                <LoadingInput
                  name="name"
                  loading={loading}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <Button disabled={loading || name.length < 4} onClick={onSave}>
                Cadastrar
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Financial/PaymentCostCenter/index.jsx